export enum NotificationTriggerType {
  beginning               = 0,
  initialSubmission       = 1,
  approval                = 2,
  rejection               = 3,
  completion              = 4,
  formSectionCompletion   = 5,
  externalFormCompletion  = 6,
  payment                 = 7,
  action                  = 8,
  sla                     = 9,
  relative                = 10,
  assignment              = 11,
  check                   = 12,
}
